import { Routes } from '@angular/router';

export const SERVICETYPE_ROUTES: Routes = [
  {
    path: 'channels/service-types/view-edit/:serviceTypeId',
    loadComponent: () =>
      import('./service-type-view-edit/service-type-view-edit.component').then(
        (com) => com.ServiceTypeViewEditComponent
      ),
    title: 'View/Edit Service Types',
  },
  {
    path: 'channels/service-types/add',
    loadComponent: () =>
      import('./service-type-add/service-type-add.component').then(
        (com) => com.ServiceTypeAddComponent
      ),
    title: 'Add Service Type',
  },
];
